export default __webpack_public_path__ + "img/7d8316203e2fdff3e4787be5f377bb92.svg";